import { styled } from '../../hooks/theme';
import { getCssFont } from '../../styles';
import { Tokens } from '../../types';

export const DialogContainer = styled.div`
  display: flex;

  flex-direction: column;
  gap: 2rem;
`;

export const DialogBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DialogContentText = styled.div`
  ${props => getCssFont(props.theme.font.desktop.paragraph.p2.regular)}
  color: ${props => props.theme.colors.neutral.grey[70]};
`;
DialogContentText.defaultProps = {
  theme: Tokens.eixods,
};
